/* True Paleo — JS global do tema (vanilla, sem dependências).
   API pública: window.TP  (money, cart.add/change/refresh/open/close, radio, onReady)
   Atributos de dados reconhecidos (delegação de eventos):
     [data-tp-add]            data-variant="ID" data-qty="1"   |  data-items='[{"id":1,"quantity":2}]'
                              data-variant-source="#seletor" (lê o value de um <select>/<input>)
     [data-tp-open-cart] / [data-tp-close-cart]
     [data-tp-menu-toggle]    alterna #tp-nav-mobile
     [data-tp-sticky]         barra fixa: data-target="#comprar" (aparece após 520px, some perto do alvo)
     [data-tp-gallery]        contém [data-tp-main] (img) e botões [data-tp-thumb][data-src][data-srcset]
     [data-tp-cep]            estimador de prazo por CEP (data-free-from em centavos, data-dispatch-days)
     iframe[data-tp-lazy]     carrega o src (data-src) quando chega perto da tela
     .reveal                  entra ao rolar (adiciona .is-in)
*/
(function () {
  "use strict";
  var doc = document, root = doc.documentElement;
  root.classList.add("js");

  var TP = (window.TP = window.TP || {});
  var fmt = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
  TP.money = function (cents) { return fmt.format((cents || 0) / 100); };
  TP.onReady = function (fn) { if (doc.readyState !== "loading") fn(); else doc.addEventListener("DOMContentLoaded", fn); };
  TP.$ = function (s, c) { return (c || doc).querySelector(s); };
  TP.$$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };

  /* ---------------- Carrinho ---------------- */
  var routes = (window.theme && window.theme.routes) || { cart: "/cart", cartAdd: "/cart/add.js", cartChange: "/cart/change.js", cartJson: "/cart.js", root: "/" };
  var busy = false;

  function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || "Erro no carrinho"); e.data = j; throw e; }
        return j;
      });
    });
  }

  function setCount(n) {
    TP.$$(".cart-count").forEach(function (el) { el.textContent = n; el.setAttribute("data-count", n); });
  }

  TP.cart = {
    get: function () { return fetch(routes.cartJson, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); },
    refresh: function () {
      return fetch((routes.root || "/") + "?sections=cart-drawer", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data["cart-drawer"];
          if (!html) return;
          var tmp = doc.createElement("div"); tmp.innerHTML = html;
          var next = tmp.querySelector("[data-tp-drawer-inner]");
          var cur = TP.$("[data-tp-drawer-inner]");
          if (next && cur) cur.innerHTML = next.innerHTML;
          var cnt = next && next.getAttribute("data-count");
          if (cnt != null) setCount(cnt);
        });
    },
    open: function () { root.classList.add("tp-cart-open"); var d = TP.$("#tp-drawer"); if (d) { d.setAttribute("aria-hidden", "false"); } },
    close: function () { root.classList.remove("tp-cart-open"); var d = TP.$("#tp-drawer"); if (d) { d.setAttribute("aria-hidden", "true"); } },
    add: function (items, opts) {
      opts = opts || {};
      if (busy) return Promise.resolve();
      busy = true;
      return post(routes.cartAdd, { items: items })
        .then(function () { return TP.cart.refresh(); })
        .then(function () { if (opts.open !== false) TP.cart.open(); doc.dispatchEvent(new CustomEvent("tp:cart-add", { detail: { items: items } })); })
        .catch(function (e) { TP.cart.open(); showCartError(e.message); })
        .then(function () { busy = false; });
    },
    change: function (line, quantity) {
      if (busy) return Promise.resolve();
      busy = true;
      return post(routes.cartChange, { line: line, quantity: quantity })
        .then(function () { return TP.cart.refresh(); })
        .catch(function (e) { showCartError(e.message); })
        .then(function () { busy = false; });
    }
  };

  function showCartError(msg) {
    var box = TP.$("[data-tp-cart-error]");
    if (box) { box.textContent = msg; box.hidden = false; setTimeout(function () { box.hidden = true; }, 6000); }
  }

  /* ---------------- Delegação de cliques ---------------- */
  doc.addEventListener("click", function (ev) {
    var t = ev.target;
    if (!t.closest) return;

    var go = t.closest("[data-go]");
    if (go) { ev.preventDefault(); window.location.href = go.getAttribute("data-go"); return; }

    var add = t.closest("[data-tp-add]");
    if (add) {
      ev.preventDefault();
      var items;
      if (add.getAttribute("data-items")) {
        try { items = JSON.parse(add.getAttribute("data-items")); } catch (e) { items = null; }
      } else {
        var id = add.getAttribute("data-variant");
        var srcSel = add.getAttribute("data-variant-source");
        if (srcSel) { var src = TP.$(srcSel); if (src) id = src.value; }
        if (id) items = [{ id: Number(id), quantity: Number(add.getAttribute("data-qty") || 1) }];
      }
      if (!items || !items.length) return;
      add.classList.add("is-loading");
      TP.cart.add(items).then(function () { add.classList.remove("is-loading"); });
      return;
    }

    if (t.closest("[data-tp-open-cart]")) { ev.preventDefault(); TP.cart.refresh().then(TP.cart.open, TP.cart.open); return; }
    if (t.closest("[data-tp-close-cart]")) { ev.preventDefault(); TP.cart.close(); return; }

    var chg = t.closest("[data-tp-line]");
    if (chg) {
      ev.preventDefault();
      TP.cart.change(Number(chg.getAttribute("data-line")), Number(chg.getAttribute("data-qty")));
      return;
    }

    var mt = t.closest("[data-tp-menu-toggle]");
    if (mt) {
      var nav = TP.$("#tp-nav-mobile");
      if (nav) { var open = nav.hidden; nav.hidden = !open; mt.setAttribute("aria-expanded", String(open)); }
      return;
    }

    var thumb = t.closest("[data-tp-thumb]");
    if (thumb) {
      var g = thumb.closest("[data-tp-gallery]");
      var main = g && TP.$("[data-tp-main]", g);
      if (main) {
        main.src = thumb.getAttribute("data-src");
        if (thumb.getAttribute("data-srcset")) main.srcset = thumb.getAttribute("data-srcset"); else main.removeAttribute("srcset");
        if (thumb.getAttribute("data-alt")) main.alt = thumb.getAttribute("data-alt");
        TP.$$("[data-tp-thumb]", g).forEach(function (b) { b.setAttribute("aria-current", String(b === thumb)); });
      }
      return;
    }
  });

  doc.addEventListener("keydown", function (e) { if (e.key === "Escape") TP.cart.close(); });

  /* ---------------- Grupo de opções (radio) ---------------- */
  /* TP.radio(container, onChange): container com filhos [role=radio]; troca aria-checked e chama onChange(el). */
  TP.radio = function (container, onChange) {
    if (!container) return;
    var opts = function () { return TP.$$('[role="radio"]', container); };
    container.addEventListener("click", function (e) {
      var el = e.target.closest('[role="radio"]');
      if (!el || !container.contains(el)) return;
      opts().forEach(function (o) { o.setAttribute("aria-checked", String(o === el)); o.tabIndex = o === el ? 0 : -1; });
      if (onChange) onChange(el);
    });
    container.addEventListener("keydown", function (e) {
      if (["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp"].indexOf(e.key) < 0) return;
      var list = opts(), i = list.indexOf(doc.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var n = list[(i + (e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : list.length - 1)) % list.length];
      n.focus(); n.click();
    });
  };

  /* ---------------- Revelar ao rolar ---------------- */
  function initReveal() {
    var els = TP.$$(".reveal:not(.is-in)");
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- vídeos dos creators (arquivo próprio, só carrega ao tocar) ---------------- */
  function initReels() {
    var frames = TP.$$("[data-reel]");
    frames.forEach(function (fr) {
      var v = fr.querySelector("video"), btn = fr.querySelector(".reel__play");
      if (!v || !btn) return;
      function start() {
        TP.$$("[data-reel] video").forEach(function (o) { if (o !== v) o.pause(); });
        if (!v.getAttribute("src")) { v.src = v.getAttribute("data-src"); }
        v.controls = true; v.muted = false;
        var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
      }
      btn.addEventListener("click", start);
      v.addEventListener("play", function () { fr.classList.add("is-playing"); });
      v.addEventListener("ended", function () { fr.classList.remove("is-playing"); v.controls = false; v.load(); });
    });
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (!en.isIntersecting && !en.target.paused) en.target.pause(); });
    }, { threshold: 0.2 });
    TP.$$("[data-reel] video").forEach(function (v) { io.observe(v); });
  }
  /* ---------------- Barra de compra fixa (mobile) ---------------- */
  function initSticky() {
    var bar = TP.$("[data-tp-sticky]");
    if (!bar) return;
    var sel = bar.getAttribute("data-target") || "#comprar";
    var tick = function () {
      var tg = TP.$(sel), near = false;
      if (tg) { var r = tg.getBoundingClientRect(); near = r.top < innerHeight * 0.7 && r.bottom > 0; }
      bar.classList.toggle("is-on", window.scrollY > 520 && !near);
      bar.setAttribute("aria-hidden", String(!bar.classList.contains("is-on")));
    };
    tick(); window.addEventListener("scroll", tick, { passive: true });
  }

  /* ---------------- Estimador de prazo por CEP ---------------- */
  var REGION = { SP: [2, 4], RJ: [3, 5], MG: [3, 5], ES: [3, 6], PR: [3, 6], SC: [3, 6], RS: [4, 7], DF: [3, 6], GO: [4, 7], MS: [4, 8], MT: [5, 9], BA: [5, 9], SE: [5, 9], AL: [5, 9], PE: [5, 9], PB: [5, 10], RN: [5, 10], CE: [5, 10], PI: [6, 10], MA: [6, 11], AM: [8, 14], PA: [7, 12], AC: [9, 15], RO: [8, 14], RR: [9, 15], AP: [9, 15], TO: [6, 11] };
  var DIGIT = { 0: [2, 4], 1: [2, 4], 2: [3, 6], 3: [3, 5], 4: [5, 9], 5: [5, 10], 6: [6, 13], 7: [4, 10], 8: [3, 6], 9: [4, 7] };

  function initCep(box) {
    var form = TP.$("form", box), input = TP.$("input", box), out = TP.$("[data-cep-out]", box), err = TP.$("[data-cep-err]", box);
    var freeFrom = Number(box.getAttribute("data-free-from") || 15000);
    var dispatch = Number(box.getAttribute("data-dispatch-days") || 5);
    input.addEventListener("input", function () {
      var v = input.value.replace(/\D/g, "").slice(0, 8);
      input.value = v.length > 5 ? v.slice(0, 5) + "-" + v.slice(5) : v;
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var digits = input.value.replace(/\D/g, "");
      err.hidden = true; out.hidden = true;
      if (digits.length !== 8) { err.hidden = false; return; }
      var btn = TP.$("button", form); btn.disabled = true;
      fetch("https://viacep.com.br/ws/" + digits + "/json/")
        .then(function (r) { return r.json(); })
        .catch(function () { return null; })
        .then(function (d) {
          btn.disabled = false;
          if (d && (d.erro || !d.uf)) { err.hidden = false; return; }
          var uf = d && d.uf, city = (d && d.localidade) || "";
          var t = uf ? (REGION[uf] || [6, 12]) : (DIGIT[digits.charAt(0)] || [6, 12]);
          var min = 1 + t[0], max = dispatch + t[1];
          TP.cart.get().then(function (c) { return c.total_price; }, function () { return 0; }).then(function (total) {
            var free = total >= freeFrom;
            out.innerHTML =
              "<p><strong>" + (uf ? city + "/" + uf : "CEP " + input.value) + "</strong></p>" +
              "<p>Chega em cerca de <strong>" + min + " a " + max + " dias úteis</strong> depois do pagamento.</p>" +
              "<p>Frete: <strong>" + (free ? "grátis neste pedido" : "grátis acima de " + TP.money(freeFrom)) + "</strong>" + (free ? "" : "; abaixo disso, o valor aparece no checkout.") + "</p>";
            out.hidden = false;
          });
        });
    });
  }


  /* ---------------- Caixas de compra ---------------- */
  /* data-tp-buybox="deo" | "pack".  Valores monetários em centavos nos data-attributes. */
  function q(el, s) { return el.querySelector(s); }
  function qa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function setText(el, s, v) { var n = q(el, s); if (n) n.textContent = v; }
  function freeLine(el, total) {
    /* [data-free-line] (não [data-free], que agora é a quantidade de brindes das opções do balm) */
    var from = Number(el.getAttribute("data-free-from") || 0), n = q(el, "[data-free-line]");
    if (!n) return;
    n.innerHTML = total >= from ? "<strong>Frete grátis neste pedido.</strong>" : "Faltam " + TP.money(from - total) + " para o frete grátis.";
  }

  /* ?kit=N na URL marca a opção (botões da home levam pra página do produto). attr = data-units (deo) ou data-qty (balm). */
  function kitFromUrl(el, attr) {
    try {
      var k = new URLSearchParams(location.search).get("kit"); if (!k) return -1;
      var opts = qa(el, "[" + attr + "]"), i = opts.findIndex(function (o) { return o.getAttribute(attr) === String(k); });
      return i;
    } catch (e) { return -1; }
  }

  function initDeo(el) {
    var tiers = qa(el, '[data-tier]'), rows = {}, state = { tier: Number(el.getAttribute("data-default-tier") || 1), lav: 0 };
    var fromUrl = kitFromUrl(el, "data-units"); if (fromUrl >= 0) state.tier = fromUrl;
    qa(el, "[data-aroma-row]").forEach(function (r) { rows[r.getAttribute("data-aroma-row")] = r; });
    var listUnit = Number(el.getAttribute("data-list-unit"));
    var from = Number(el.getAttribute("data-free-from"));
    function cur() { var t = tiers[state.tier]; return { units: +t.dataset.units, total: +t.dataset.total, el: t }; }
    function render() {
      var t = cur(), nat = t.units - state.lav;
      tiers.forEach(function (x, i) { x.setAttribute("aria-checked", String(i === state.tier)); x.tabIndex = i === state.tier ? 0 : -1; });
      qa(rows.nat, "[data-count]")[0].textContent = nat; qa(rows.lav, "[data-count]")[0].textContent = state.lav;
      rows.nat.classList.toggle("is-on", nat > 0); rows.lav.classList.toggle("is-on", state.lav > 0);
      q(rows.nat, "[data-minus]").disabled = nat === 0; q(rows.nat, "[data-plus]").disabled = nat >= t.units;
      q(rows.lav, "[data-minus]").disabled = state.lav === 0; q(rows.lav, "[data-plus]").disabled = state.lav >= t.units;
      var mix = state.lav === 0 ? "Cheiro Natural" : nat === 0 ? "Lavanda" : nat + " Natural + " + state.lav + " Lavanda";
      var save = t.units * listUnit - t.total;
      setText(el, "[data-cta-total]", TP.money(t.total));
      q(el, "[data-mix]").innerHTML = mix + " · " + (t.units > 1 ? TP.money(Math.round(t.total / t.units)) + " por unidade" : "50 g") +
        (save > 0 ? " · você economiza <strong class=\"u-beef\">" + TP.money(save) + "</strong>" : "");
      var hint = q(el, "[data-hint]"), best = tiers[tiers.length - 2];
      if (hint) {
        var miss = from - t.total, bu = +best.dataset.units;
        hint.hidden = !(miss > 0 && t.units < bu);
        if (!hint.hidden) hint.innerHTML = "<strong class=\"u-beef\">Falta " + TP.money(miss) + " para o frete grátis.</strong> Leve " + bu + " unidades por " + TP.money(+best.dataset.total) + " <span style=\"text-decoration:underline\">e escolher esta opção</span>.";
      }
    }
    tiers.forEach(function (x, i) { x.addEventListener("click", function () { state.tier = i; state.lav = Math.min(state.lav, cur().units); render(); }); });
    el.addEventListener("keydown", function (e) {
      if (!e.target.closest || !e.target.closest('[data-tier]')) return;
      var k = e.key; if (["ArrowDown", "ArrowUp", "ArrowRight", "ArrowLeft"].indexOf(k) < 0) return;
      e.preventDefault(); state.tier = (state.tier + (k === "ArrowDown" || k === "ArrowRight" ? 1 : tiers.length - 1)) % tiers.length;
      state.lav = Math.min(state.lav, cur().units); render(); tiers[state.tier].focus();
    });
    el.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-minus],button[data-plus]"); if (b) {
        var row = b.closest("[data-aroma-row]"), which = row.getAttribute("data-aroma-row"), t = cur();
        var dir = b.hasAttribute("data-plus") ? 1 : -1;
        if (which === "lav") state.lav = Math.max(0, Math.min(t.units, state.lav + dir));
        else state.lav = Math.max(0, Math.min(t.units, state.lav - dir));
        render(); return;
      }
      if (e.target.closest("[data-hint]")) { state.tier = tiers.length - 2; render(); return; }
      var sub = e.target.closest("[data-submit]"); if (sub) {
        var t2 = cur(), n = t2.units - state.lav, items = [];
        if (n > 0) items.push({ id: +el.getAttribute("data-variant-nat"), quantity: n });
        if (state.lav > 0) items.push({ id: +el.getAttribute("data-variant-lav"), quantity: state.lav });
        sub.classList.add("is-loading"); TP.cart.add(items).then(function () { sub.classList.remove("is-loading"); });
      }
    });
    render();
  }

  function initPack(el) {
    var opts = qa(el, '[data-opt]'), segWrap = q(el, "[data-seg]"), state = { i: Number(el.getAttribute("data-default") || 0), aroma: "nat", lav: 0 };
    var photo = q(el, "[data-photo]");
    var fromUrl = kitFromUrl(el, el.getAttribute("data-kit-attr") || "data-qty"); if (fromUrl >= 0) state.i = fromUrl;
    /* Linhas de aroma (− / +) pros desodorantes grátis do kit do balm: nat + lav = brindes. */
    var aromas = q(el, "[data-aromas]"), rowNat = q(el, '[data-aroma-row="nat"]'), rowLav = q(el, '[data-aroma-row="lav"]');
    function renderAromas(c) {
      if (!aromas) return;
      var free = c.free || 0; aromas.hidden = !(c.pick && free > 0);
      if (state.lav > free) state.lav = free;
      var nat = free - state.lav;
      qa(rowNat, "[data-count]")[0].textContent = nat; qa(rowLav, "[data-count]")[0].textContent = state.lav;
      rowNat.classList.toggle("is-on", nat > 0); rowLav.classList.toggle("is-on", state.lav > 0);
      q(rowNat, "[data-minus]").disabled = nat === 0; q(rowNat, "[data-plus]").disabled = nat >= free;
      q(rowLav, "[data-minus]").disabled = state.lav === 0; q(rowLav, "[data-plus]").disabled = state.lav >= free;
      var hint = q(el, "[data-aroma-hint]");
      if (hint) hint.textContent = free === 1 ? "1 desodorante grátis: escolha o aroma." : free + " desodorantes grátis: pode levar " + free + " iguais ou um de cada.";
    }
    function cur() {
      var o = opts[state.i], lav = state.aroma === "lav" && o.hasAttribute("data-total-lav");
      return {
        o: o, lav: lav,
        total: +(lav ? o.dataset.totalLav : o.dataset.total), list: +(lav ? o.dataset.listLav : o.dataset.list),
        variant: +(lav ? o.dataset.variantLav : o.dataset.variant), pick: o.dataset.pick === "true",
        qty: +(o.dataset.qty || 1), free: +(o.dataset.free || 0),
        deo: +(state.aroma === "lav" ? o.dataset.deoLav : o.dataset.deoNat) || 0,
        img: lav ? (o.dataset.imgLav || o.dataset.img) : o.dataset.img
      };
    }
    function render() {
      var c = cur(), save = c.list - c.total;
      opts.forEach(function (x, i) { x.setAttribute("aria-checked", String(i === state.i)); x.tabIndex = i === state.i ? 0 : -1; });
      if (segWrap) { segWrap.hidden = !c.pick; qa(segWrap, '[role="radio"]').forEach(function (b) { b.setAttribute("aria-checked", String(b.dataset.aroma === state.aroma)); }); }
      q(el, "[data-sum-total]").textContent = TP.money(c.total);
      var l = q(el, "[data-sum-list]"); l.textContent = save > 0 ? TP.money(c.list) : ""; l.hidden = !(save > 0);
      var s = q(el, "[data-sum-save]"); s.hidden = !(save > 0); s.textContent = "economia de " + TP.money(save);
      q(el, "[data-cta] > span:last-child").textContent = c.o.dataset.ctaText;
      freeLine(el, c.total);
      renderAromas(c);
      if (photo && c.img) { photo.src = c.img; photo.removeAttribute("srcset"); }
    }
    opts.forEach(function (x, i) { x.addEventListener("click", function () { state.i = i; state.lav = 0; render(); }); });
    if (aromas) el.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-minus],button[data-plus]"); if (!b || !aromas.contains(b)) return;
      var c = cur(), free = c.free || 0, which = b.closest("[data-aroma-row]").getAttribute("data-aroma-row"), dir = b.hasAttribute("data-plus") ? 1 : -1;
      if (which === "lav") state.lav = Math.max(0, Math.min(free, state.lav + dir)); else state.lav = Math.max(0, Math.min(free, state.lav - dir));
      render();
    });
    el.addEventListener("keydown", function (e) {
      if (!e.target.closest || !e.target.closest('[data-opt]')) return;
      var k = e.key; if (["ArrowDown", "ArrowUp", "ArrowRight", "ArrowLeft"].indexOf(k) < 0) return;
      e.preventDefault(); state.i = (state.i + (k === "ArrowDown" || k === "ArrowRight" ? 1 : opts.length - 1)) % opts.length; render(); opts[state.i].focus();
    });
    if (segWrap) TP.radio(segWrap, function (b) { state.aroma = b.dataset.aroma; render(); });
    q(el, "[data-cta]").addEventListener("click", function (e) {
      var c = cur(), btn = e.currentTarget; btn.classList.add("is-loading");
      var items = [{ id: c.variant, quantity: c.qty }];
      if (c.free > 0 && aromas) {
        var nat = c.free - state.lav, idNat = +c.o.dataset.deoNat, idLav = +c.o.dataset.deoLav;
        if (nat > 0 && idNat) items.push({ id: idNat, quantity: nat });
        if (state.lav > 0 && idLav) items.push({ id: idLav, quantity: state.lav });
      } else if (c.free > 0 && c.deo) items.push({ id: c.deo, quantity: c.free });
      TP.cart.add(items).then(function () { btn.classList.remove("is-loading"); });
    });
    render();
  }

  function initBuyboxes() {
    TP.$$("[data-tp-buybox]:not([data-ready])").forEach(function (el) {
      el.setAttribute("data-ready", "1");
      var k = el.getAttribute("data-tp-buybox");
      if (k === "deo") initDeo(el); else initPack(el);
    });
  }
  TP.onReady(initBuyboxes);
  doc.addEventListener("shopify:section:load", initBuyboxes);
  /* Vindo da home com ?kit=N#comprar: rola até a caixa de compra. O embed do Kaching às vezes
     emenda "&variant=…" depois do #, o que quebra a âncora; por isso o scroll é feito aqui. */
  TP.onReady(function () {
    if (!/^#comprar/.test(location.hash)) return;
    var box = doc.getElementById("comprar") || doc.getElementById("comprar-lp");
    if (box) setTimeout(function () { box.scrollIntoView({ behavior: "smooth", block: "start" }); }, 350);
  });

  TP.onReady(function () {
    initReveal(); initReels(); initSticky();
    TP.$$("[data-tp-cep]").forEach(initCep);
    TP.cart.get().then(function (c) { setCount(c.item_count); }).catch(function () {});
  });
  /* Reaplica após o editor de temas recarregar uma seção */
  doc.addEventListener("shopify:section:load", function () { initReveal(); initReels(); TP.$$("[data-tp-cep]").forEach(initCep); });

  /* ---------- Black Friday: contagem regressiva ---------- */
  function initCountdowns() {
    var els = TP.$$("[data-bf-end]"); if (!els.length) return;
    function pad(n) { return n < 10 ? "0" + n : String(n); }
    function tick() {
      var now = Math.floor(Date.now() / 1000), over = true;
      els.forEach(function (el) {
        var left = +el.getAttribute("data-bf-end") - now;
        if (left <= 0) { el.classList.add("is-over"); left = 0; } else over = false;
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
        [["d", d], ["h", h], ["m", m], ["s", s]].forEach(function (p) { var n = q(el, "[data-bf-" + p[0] + "]"); if (n) n.textContent = pad(p[1]); });
      });
      if (over) { clearInterval(timer); doc.documentElement.classList.add("bf-over"); }
    }
    var timer = setInterval(tick, 1000); tick();
  }
  TP.onReady(initCountdowns);
  doc.addEventListener("shopify:section:load", initCountdowns);
})();
